import React, { useState, useEffect } from 'react';
import { CreditCard, X } from 'lucide-react';
import ModalMetodosCobro from './ModalMetodosCobro';

const ModalGestionCobros = ({ isOpen, onClose, invoice }) => {
  const [cantidadCobrada, setCantidadCobrada] = useState(0);
  const [fechaCobro, setFechaCobro] = useState(new Date().toISOString().slice(0, 10));
  const [metodoCobro, setMetodoCobro] = useState('Efectivo'); // Asumir un método por defecto
  const [accion, setAccion] = useState('registrar'); // 'registrar' o 'elegir'
  const [isModalMetodosCobroOpen, setIsModalMetodosCobroOpen] = useState(false);

  useEffect(() => {
    if (isOpen && invoice) {
      // Inicializar cantidad cobrada con el total pendiente de la factura
      setCantidadCobrada(invoice.total - (invoice.cobrado || 0)); // Asumiendo que invoice.cobrado existe
      setFechaCobro(new Date().toISOString().slice(0, 10));
      setMetodoCobro('Efectivo');
      setAccion('registrar');
    }
  }, [isOpen, invoice]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Lógica para registrar/elegir cobro
    console.log('Submit Cobro:', { cantidadCobrada, fechaCobro, metodoCobro, accion, invoiceId: invoice.id_factura });
    alert('Lógica de cobro no implementada aún. Ver consola.');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-3xl max-h-[90vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-gray-50">
          <h2 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
            <CreditCard size={20} className="text-blue-600" />
            Gestión de cobros de la factura {invoice?.numero_factura || 'N/A'}
          </h2>
          <button onClick={onClose} className="bg-none border-none text-gray-600 text-2xl p-1 rounded hover:bg-gray-200">
            <X size={24} />
          </button>
        </div>
        
        {/* Modal Body */}
        <div className="p-5">
          <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-5 text-sm text-blue-800">
            Puedes registrar un nuevo cobro (sin conciliar con un movimiento bancario) o elegir un movimiento existente. Si eliges un movimiento existente se creará el cobro y se conciliará automáticamente.
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-6">
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2 font-medium">
                  <input 
                    type="radio" 
                    id="registrar" 
                    name="accion" 
                    value="registrar" 
                    checked={accion === 'registrar'}
                    onChange={(e) => setAccion(e.target.value)}
                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                  />
                  <label htmlFor="registrar">Registrar cobro</label>
                </div>
                
                {accion === 'registrar' && (
                  <div className="grid grid-cols-[200px_1fr] gap-4 items-center ml-6">
                    <label htmlFor="cantidadCobrada" className="font-medium text-right text-gray-700">Cantidad cobrada</label>
                    <input 
                      type="number" 
                      id="cantidadCobrada" 
                      value={cantidadCobrada}
                      onChange={(e) => setCantidadCobrada(e.target.value)}
                      className="p-2 border border-gray-300 rounded-md text-sm max-w-[200px] focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                      step="0.01"
                    />
                    
                    <label htmlFor="fechaCobro" className="font-medium text-right text-gray-700">Fecha</label>
                    <input 
                      type="date" 
                      id="fechaCobro" 
                      value={fechaCobro}
                      onChange={(e) => setFechaCobro(e.target.value)}
                      className="p-2 border border-gray-300 rounded-md text-sm max-w-[200px] focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                    />
                    
                    <label htmlFor="metodoCobro" className="font-medium text-right text-gray-700">Método de cobro</label>
                    <div className="flex items-center gap-2">
                      <select 
                        id="metodoCobro" 
                        value={metodoCobro}
                        onChange={(e) => setMetodoCobro(e.target.value)}
                        className="p-2 border border-gray-300 rounded-md text-sm bg-white max-w-[200px] focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                      >
                        <option>Efectivo</option>
                        {/* Más opciones de método de cobro */}
                      </select>
                      <button type="button" onClick={() => setIsModalMetodosCobroOpen(true)} className="text-blue-600 hover:underline text-sm">+ Nuevo método</button>
                    </div>
                    
                    <label className="font-medium text-right text-gray-700">Estado de la factura</label>
                    <span className="bg-green-500 text-white px-2 py-1 rounded-md text-xs font-medium">Pagado</span>
                  </div>
                )}
                
                <div className="flex items-center gap-2 font-medium mt-6">
                  <input 
                    type="radio" 
                    id="elegir" 
                    name="accion" 
                    value="elegir" 
                    checked={accion === 'elegir'}
                    onChange={(e) => setAccion(e.target.value)}
                    className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                  />
                  <label htmlFor="elegir">Elegir movimiento existente</label>
                </div>
              </div>
            </div>

            {accion === 'registrar' && (
              <div className="ml-6 mt-4">
                <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                  Registrar
                </button>
              </div>
            )}
          </form>

          <div className="mt-6">
            <h3 className="font-semibold mb-3 text-gray-700">Cobros realizados hasta la fecha</h3>
            <table className="w-full border-collapse bg-white border border-gray-200 rounded-md">
              <thead>
                <tr>
                  <th className="bg-gray-50 p-3 text-left text-xs font-semibold text-gray-600 border-b border-gray-200">Fecha</th>
                  <th className="bg-gray-50 p-3 text-left text-xs font-semibold text-gray-600 border-b border-gray-200">Cantidad</th>
                  <th className="bg-gray-50 p-3 text-left text-xs font-semibold text-gray-600 border-b border-gray-200">Método de cobro</th>
                  <th className="bg-gray-50 p-3 text-left text-xs font-semibold text-gray-600 border-b border-gray-200">Estado de la conciliación</th>
                  <th className="bg-gray-50 p-3 text-left text-xs font-semibold text-gray-600 border-b border-gray-200">Operaciones</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-3 border-b border-gray-100 text-sm">24/07/2025</td>
                  <td className="p-3 border-b border-gray-100 text-sm">546,25 €</td>
                  <td className="p-3 border-b border-gray-100 text-sm">Efectivo</td>
                  <td className="p-3 border-b border-gray-100 text-sm"><span className="w-3 h-3 bg-red-500 rounded-full inline-block"></span></td>
                  <td className="p-3 border-b border-gray-100 text-sm">
                    <div className="flex gap-1">
                      <button className="w-6 h-6 border-none bg-gray-100 cursor-pointer rounded-sm flex items-center justify-center"></button>
                      <button className="w-6 h-6 border-none bg-gray-100 cursor-pointer rounded-sm flex items-center justify-center"></button>
                      <button className="w-6 h-6 border-none bg-gray-100 cursor-pointer rounded-sm flex items-center justify-center">️</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="mt-3 text-xs text-gray-600">
              Mostrando página 1 de 1 (1 elementos en total)
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="p-4 border-t border-gray-200 flex justify-end gap-3 bg-gray-50">
          <button onClick={onClose} className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2">
            Cerrar
          </button>
        </div>
      </div>
      <ModalMetodosCobro isOpen={isModalMetodosCobroOpen} onClose={() => setIsModalMetodosCobroOpen(false)} />
    </div>
  );
};

export default ModalGestionCobros;
// Added a comment to force re-compilation.